'use client';
import { createProps, splitProps } from '@chakra-ui/utils';

const numberInputProps = createProps()([
  "allowMouseWheel",
  "aria-describedby",
  "aria-label",
  "aria-labelledby",
  "clampValueOnBlur",
  "defaultValue",
  "format",
  "getAriaValueText",
  "id",
  "inputMode",
  "isDisabled",
  "isInvalid",
  "isReadOnly",
  "isRequired",
  "isValidCharacter",
  "keepWithinRange",
  "max",
  "min",
  "name",
  "onBlur",
  "onChange",
  "onFocus",
  "onInvalid",
  "parse",
  "pattern",
  "precision",
  "step",
  "value",
  "focusInputOnChange"
]);
const splitNumberInputProps = (props) => splitProps(props, numberInputProps);

export { numberInputProps, splitNumberInputProps };
